import React, { Component } from 'react';
import './App.css';
import Moment from 'moment';
import './dlButton.css';
import Yup from './const';

class App extends Component {
    constructor(props) {
        super(props);

        console.log("%c1U2D time to CLOWN", "color: #f00;font-size: 10em; font-weight: bold; text-shadow: .03em .02em #000;");

        this.state = {
            daysActive: 4,
            filePath: null,
            fileName: null,
            hasAccessUser: false,
            hasAccessGuest: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.go = this.go.bind(this);
    };

    componentDidMount() {
        fetch('./data/build.json')
            .then(response => response.json())
            .then(data => {
                const expireDate = Moment(data.buildDate, 'YYYY-MM-DD').add(4, 'days');

                this.setState(prevState => ({
                    ...prevState,
                    buildDate: Moment(data.buildDate, 'YYYY-MM-DD'),
                    expireDate,
                    fileName: data.fileName,
                    canShowLink: ((eDate = Moment().subtract(1, 'w')) => {
                        return Moment().isSameOrBefore(eDate);
                    })(expireDate)
                }))
            });
    }

    handleClick() {
        const {
            fileName
        } = this.state;

        this.setState(prevState => ({
            ...prevState,
            filePath: `${fileName}`,
            fileName: fileName
        }),
            () => {
                document.getElementById('DL').click();

                setTimeout(() => {
                    this.setState(prevState => ({
                        ...prevState,
                        filePath: null
                    }))
                });
            });
    }

    go() {
        const n = document.getElementById('uName').value;
        const p = document.getElementById('pWord').value;
        const data = Yup(n, p);

        this.setState(prevState => ({
            ...prevState,
            hasAccessGuest: data.guest && data.access,
            hasAccessUser: !data.guest && data.access
        }));
    }

    render() {
        return (
            <div>
                {
                    !this.state.hasAccessUser && 
                    !this.state.hasAccessGuest && 
                    <div>
                        <input type="text" id="uName" placeholder="User name" />
                        <input type="password" id="pWord" placeholder="Password" />
                        <button onClick={this.go}>GO</button>
                    </div>
                }
                {
                    this.state.canShowLink &&
                    this.state.hasAccessUser &&
                    <div>
                        Days remaining: {this.state.expireDate.diff(Moment(), 'days', true).toFixed(1)}
                        <br />
                        <button className="button" onClick={this.handleClick}>DOWNLOAD</button>
                        {
                            this.state.filePath && this.state.fileName &&
                            <a style={{display:'none'}} href={this.state.filePath} download={this.state.fileName} id="DL">Download the file</a>
                        }
                    </div>
                }
                {
                    this.state.hasAccessGuest &&
                    <p>guest download</p>
                }
                {
                    !this.state.canShowLink &&
                    this.state.hasAccessUser &&
                    <span>Download has expired.</span>
                }
                {
                    !this.state.canShowLink &&
                    this.state.hasAccessGuest &&
                    <span>Download has expired.</span>
                }
            </div>
        );
    };

}

export default App;


// WEBPACK FOOTER //
// ./src/App.js